import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgActivityUpdate = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4.5 3.75H12C12.3978 3.75 12.7794 3.90804 13.0607 4.18934C13.342 4.47064 13.5 4.85218 13.5 5.25V10.5",
			stroke: "currentColor",
			strokeWidth: 1.7,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5 14.25H6C5.60218 14.25 5.22064 14.092 4.93934 13.8107C4.65804 13.5294 4.5 13.1478 4.5 12.75V7.5",
			stroke: "currentColor",
			strokeWidth: 1.7,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.25 8.25L13.5 10.5L15.75 8.25",
			stroke: "currentColor",
			strokeWidth: 1.7,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.75 9.75L4.5 7.5L2.25 9.75",
			stroke: "currentColor",
			strokeWidth: 1.7,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgActivityUpdate;
